export default {
    title: "Cookies",
    settingsTitle: "Settings cookies",
    settingsLabel: "Set cookies",
    acceptLabel: "I accept all",
    saveLabel:"Save settings",
    cancelLabel:"Cancel",
    message: 'By clicking “I accept all”, you agree to our use of your information as described in this Policy.',
    essentail: {
        category: 'These are absolutely necessary for the functioning of the website.',
        name: 'These are absolutely necessary for the functioning of the website.',
        description:'Without them, you wouldn’t be able to use basic services. Cookies are files with small amount of data, which may include an anonymous unique identifier. Cookies are sent to your browser from a web site and stored on your computers hard drive.<br/> JSON Formatter websites specifically uses them to enhance user experiences by remembering preferences. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent.',
    }
}
